import React from 'react';
import ChooseProjectModal from '../../components/Modals/ChooseProjectModal';

import PropTypes from 'prop-types';
import AdminSensorsReportsModal from '../Modals/AdminSensorsReportsModal';
import { useDispatch, useSelector } from 'react-redux';
import { LuBlocks } from 'react-icons/lu';
import {
  setDashboardModalVisibility,
  setCustomerDashboardModalVisibility,
  setMaintenanceDashboardModalVisibility,
} from '../../actions/DashboardActions';
import {
  setAutoRecommendedAlertsModalVisibility,
  fetchAutoRecommendedAlerts,
} from '../../actions/AutoRecommendedAlertsActions';

require('./Picker.scss');
const Picker = (props) => {
  const { value, onChange, options, isAqsAdmin, user, selectedProjectItem } =
    props;
  const dispatch = useDispatch();
  const selectedProject = useSelector(
    (state) => state.leaksList?.selectedProject
  );

  const openDashboard = () => {
    dispatch(setDashboardModalVisibility(true));
  };

  const openCustomerDashboard = () => {
    dispatch(setCustomerDashboardModalVisibility(true));
  };

  const openMaintenanceDashboard = () => {
    dispatch(setMaintenanceDashboardModalVisibility(true));
  };

  const openAutoRecommendedAlerts = () => {
    dispatch(setAutoRecommendedAlertsModalVisibility(true));
    if (selectedProject) {
      dispatch(fetchAutoRecommendedAlerts(selectedProject));
    }
  };

  // Show dashboard button if user is AQS admin OR has dashboard permission
  const canAccessDashboard = isAqsAdmin || user?.dashboard;

  // Check if dashboard is enabled for this project (default to true if not set)
  const isDashboardEnabled = selectedProjectItem?.is_dashboard !== 0;

  return (
    <>
      <div className='project-picker'>
        {canAccessDashboard && isDashboardEnabled && (
          <div className='table-actions'>
            {user?.dashboardManager && (
              <button
                onClick={openCustomerDashboard}
                className='btn btn-link customerDashboardBtn'
                title='Customer Dashboard'
              />
            )}
            {isAqsAdmin && (
              <button
                type='button'
                onClick={openAutoRecommendedAlerts}
                className='btn btn-link autoRecommendedAlertsBtn'
                title='Auto Prioritized Alerts'
              />
            )}
            {(isAqsAdmin || user?.dashboardMaintenance) && (
              <button
                type='button'
                onClick={openMaintenanceDashboard}
                className='btn btn-link maintenanceDashboardBtn'
                title='Maintenance dashboard'
                aria-label='Maintenance dashboard'
              >
                <LuBlocks aria-hidden='true' />
              </button>
            )}

            <button
              onClick={openDashboard}
              className='btn btn-link dashboardBtn'
              title='Project Dashboard'
            />
          </div>
        )}

        <ChooseProjectModal />

        <div className='admin-report-modal'>
          {isAqsAdmin && JSON.parse(process.env.REACT_APP_DASHBOARD) && (
            <AdminSensorsReportsModal />
          )}
        </div>

        <select onChange={(e) => onChange(e.target.value)} value={value}>
          {options.map((option) => (
            <option key={option.ID} value={option.ID}>
              {option.ShortName}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

Picker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Picker;
